import { isPolygonClockwise } from "@project-rouge/rg-three";
function getClockwisePolygon(polygon) {
	polygon = isPolygonClockwise(polygon) ? polygon.slice() : polygon.slice().reverse();
	return polygon;
}
export { getClockwisePolygon };

//# sourceMappingURL=index73.js.map